export default "__VITE_ASSET__Dehn$hxD__"